import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

let iso = '';

const initFAQFilter = () => {
    const parent = $('.isotope-filter');
    if (parent.length != 0) {
        iso = new Isotope('.isotope-filter', {
            itemSelector: '.feed-faq',
            percentPosition: true,
            layoutMode: 'fitRows',
            transitionDuration: 0
        });

        parent.imagesLoaded(function () {
            iso.layout();
        });
    }

    let selectedCategory = '';
    let searchText = '';

    const filterItems = () => {
        $('.feed-faq').show();
        if (selectedCategory === '' && searchText === '') {
            $('.faq-page__list').show();
            if (iso) {
                iso.arrange({ filter: '*' });
            }
            return;
        }

        $('.faq-page__list').each(function() {
            const $categoryList = $(this);
            const categorySlug = $categoryList.data('category-slug');
            const matchesCategory = selectedCategory === '' || categorySlug === selectedCategory;

            if (matchesCategory) {
                if (searchText === '') {
                    $categoryList.show();
                    if (iso) {
                        iso.arrange({
                            filter: selectedCategory === '' ? '*' : '.' + selectedCategory
                        });
                    }
                } else {
                    const $accordionItems = $categoryList.find('.feed-faq');
                    let hasVisibleItems = false;

                    $accordionItems.each(function() {
                        const itemText = $(this).text().toLowerCase();
                        const matchesSearch = itemText.includes(searchText.toLowerCase());

                        if (matchesSearch) {
                            $(this).show();
                            hasVisibleItems = true;
                        } else {
                            $(this).hide();
                        }
                    });
                    $categoryList.toggle(hasVisibleItems);
                }
            } else {
                $categoryList.hide();
            }
        });
        if (iso) {
            iso.layout();
        }
    };
    $('.faq-category-search').on('change', function() {
        selectedCategory = $(this).val();
        filterItems();
    });
    $('.faq-page__search--box input[type="text"]').on('input', function() {
        searchText = $(this).val().trim();
        filterItems();
    });

    $('.faq-page__search--box input[type="text"]').on('keyup', function(e) {
        if ((e.key === 'Backspace' || e.key === 'Delete') && $(this).val() === '') {
            searchText = '';
            filterItems();
        }
    });
};

$(document).ready(function() {
    initFAQFilter();
});

export default initFAQFilter;